import { useMemo, useState } from 'react';
import type { Chat } from '@trinity/chat';
import { CurrentSegmentIdsContext } from '@trinity/chat-components/containers/Segmentation.Dashboard/context';
import { widgetChartToChartData } from '../../utils/widget-chart';
import {
  ChartGroupByContext,
  ChartInfoContext,
  ChartThemeIdContext,
  ChartTypeContext,
  ChartViewContext,
} from '../Chat/context';
import { ChartLegendContainer } from '../Chat/Message.Response.ChartContainer';
import { WidgetChartView } from './WidgetChartView';

type Props = {
  attachment: Chat.Attachment.WidgetChart;
  projectId: number;
};

export function WidgetChartContainer({ attachment, projectId }: Props) {
  const initialChartData = useMemo(
    () => widgetChartToChartData(attachment.data, projectId, attachment.id),
    [attachment.data, attachment.id, projectId],
  );

  const chartInfo = useState(initialChartData);
  const groupBy = useState<number | null>(null);
  const chartType = useState<string | null>(attachment.data.type);
  const chartView = useState<'chart' | 'table'>('chart');
  const themeId = useState<number | null>(null);

  const segmentIds = useMemo(
    () => ({ projectId, segmentId: 0, projectParentId: 0, slug: '' }),
    [projectId],
  );

  return (
    <ChartLegendContainer>
      <ChartInfoContext.Provider value={chartInfo}>
        <ChartGroupByContext.Provider value={groupBy}>
          <ChartTypeContext.Provider value={chartType}>
            <ChartViewContext.Provider value={chartView}>
              <ChartThemeIdContext.Provider value={themeId}>
                <CurrentSegmentIdsContext.Provider value={segmentIds}>
                  <WidgetChartView title={initialChartData.title} />
                </CurrentSegmentIdsContext.Provider>
              </ChartThemeIdContext.Provider>
            </ChartViewContext.Provider>
          </ChartTypeContext.Provider>
        </ChartGroupByContext.Provider>
      </ChartInfoContext.Provider>
    </ChartLegendContainer>
  );
}

WidgetChartContainer.displayName = 'Chat.Attachments.WidgetChartContainer';
